/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
    <br>
  <div>
  <div class="formPosition">

<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
  <v-row>
    <template>
      <v-card style="margin:auto;" width="1200">
        <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="70"></v-progress-circular>
            </v-overlay>
        <v-card-title   style="background-color:#006699; color:white;border-bottom:1px solid white;">
          <v-row>
            <v-col md="8">
              <span>Novo Cliente</span>
            </v-col>
            <v-col md="2">
              <v-btn color="white"  @click="$router.push('Visualizar-Cliente')"  >Consultar Clientes <v-icon>list_alt</v-icon></v-btn>
            </v-col>
             <v-col md="2">
                <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
            v-on="on" style="float:right;color:white;">info
          </v-icon>
        </template>
        <span>Clique aqui para saber como criar um novo Produto</span>
      </v-tooltip>
            </v-col>
          </v-row>
  </v-card-title >
        <v-tabs
          v-model="tab"
          background-color="#006699"
          dark
        >
          <v-tab
            v-for="item in items"
            :key="item.tab"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!--======================== Tab Geral ========================================-->
          <v-tab-item>
              <v-card flat>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            Nome<span style="color:red;">*:</span> <v-text-field  v-model="editedItem.nome" :rules="ruleRequired" label="Nome Completo" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            Nº contribuinte<span style="color:red;">*:</span> <v-text-field v-model="editedItem.nif" :rules="ruleRequired" label="Forneça aqui" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            Morada<span style="color:red;">*:</span> <v-text-field v-model="editedItem.morada" :rules="ruleRequired"  label="Morada" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            Telefone<span style="color:red;">*:</span> <v-text-field v-model="editedItem.telefone1" :rules="ruleRequired" label="Telefone 1" ></v-text-field>
                          </v-col>
                            <v-col cols="12" sm="6" md="4">
                            Email<span style="color:red;">*:</span> <v-text-field v-model="editedItem.email"  label="Email" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            Observação<v-text-field v-model="editedItem.Observacao" label="Observação" ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" :disabled="!valid" color="green darken-1"   @click="Continuar()">Continuar</v-btn>
                    </v-card-actions>
                  </v-card>
          </v-tab-item>
          <!--====================== END Tab Geral ========================================================================= -->

           <!--======================== Tab Desconto ========================================-->
          <v-tab-item>
              <v-card flat>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
                    <v-card-text>
                        <span style="font-weight:bold;font-size:15px;">Aplicação de desconto</span>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                              <v-select
                                :items="itemsSimNao"
                                v-model="opcaoSelecionada"
                                @change="SelecionaAplicacao()"
                                item-text="descricao"
                                item-value="id"
                                filled
                                outlined
                                label="Beneficiar de desconto por Produto?"
                              ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" v-if="descontoFlag">
                             <v-combobox
                              :items="produtos"
                              v-model="produtoSelecionado"
                              item-text="produto"
                              item-value="produto"
                              filled
                              outlined
                              label="Selecione o(s) produto(s)"
                              return-object
                              @change="AdicionarTabela()"
                              @click="CarregaProdutos()"
                              >
                             </v-combobox>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" v-if="descontoFlag">
                             <v-text-field v-model="editedItemProduto.produto" :disabled="true" label="Produto" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" v-if="descontoFlag">
                             <v-text-field v-model="editedItemProduto.preco" :disabled="true" label="Preço de venda" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" v-if="descontoFlag">
                              <v-text-field  :rules="ruleNumberNObrigatorio" v-model="editedItemProduto.desconto" label="Valor do desconto(Em percentagem)" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="2" v-if="descontoFlag">
                              <v-btn fab small :disabled="editedItemProduto.desconto === ''" style="margin-top:10px;" @click="AdicionarDesconto()" color="primary"><v-icon>add</v-icon></v-btn>
                          </v-col>
                          <v-col md="6" v-if="descontoFlag">
                             <v-list style="border:1px solid #cccccc;">
                                <v-subheader>Código de Barra - Produto - Desconto( Percentagem )  - (Valor em dinheiro)</v-subheader>
                                <v-list-item-group color="primary">
                                  <v-list-item
                                    v-for="(item, i) in produtosDesconto"
                                    :key="i"
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title v-text="item.descricao"></v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                    <v-icon style="color:red;" @click="Eliminar(item)" >delete</v-icon>
                                  </v-list-item-icon>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                              <v-select
                                :items="itemsSimNao"
                                v-model="opcaodescontoglobal"
                                @change="SelecionaDescontoGlobal()"
                                 filled
                              outlined
                                item-text="descricao"
                                item-value="id"
                                label="Beneficiar de desconto Global?"
                              ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" v-if="flagDescontoGlobal">
                              <v-text-field  :rules="ruleNumberNObrigatorio" v-model="editedItemProduto.descontoGlobal" label="Valor do desconto" ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" :disabled="!valid" color="green darken-1"   @click="Save()">Submeter</v-btn>
                    </v-card-actions>
                  </v-card>
          </v-tab-item>
          <!--====================== END Tab Desconto =================================== -->
        </v-tabs-items>
      </v-card>
    </template>

  </v-row>
  </v-form>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    isLoading_: false,
    search: '',
    menuFab: null,
    menuExp: null,
    overlay: false,
    produtosDesconto: [],
    opcaodescontoglobal: null,
    opcaoSelecionada: null,
    descontoFlag: false,
    flagDescontoGlobal: false,
    dataExpiracao: '',
    dataFabrico: '',
    produtoSelecionado: null,
    valid: true,
    produtos: [],
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    editedIndex: -1,
    editedItem: {
      nome: '',
      nif: '',
      tipoFornecedor: '',
      morada: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: ''
    },
    tab: null,
    items: [
      { tab: 'Geral', content: 'Tab 1 Content' },
      { tab: 'Descontos', content: 'Tab 2 Content' }
    ],

    editedItemProduto: {
      produto: '',
      preco: '',
      desconto: '',
      descontoGlobal: ''
    },

    tipoFornecedor:
    [
      { descricao: 'Muito Bom' },
      { descricao: 'Bom' },
      { descricao: 'Médio' }
    ],
    itemsSimNao:
    [
      { id: 1, descricao: 'Sim' },
      { id: 2, descricao: 'Não' }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]+([,.][0-9]+)?$/g
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 4) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 4) { return this.initializeProdutos(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
  },

  methods: {
    Continuar () {
      if (this.$refs.form.validate()) {
        this.tab = 1
      }
    },
    async Save () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params =
          {
            pk_estudante: 0,
            nome: this.editedItem.nome,
            nif: this.editedItem.nif,
            morada: this.editedItem.morada,
            telefone1: this.editedItem.telefone1,
            telefone2: this.editedItem.telefone2,
            email: this.editedItem.email,
            observacao: this.editedItem.observacao,
            produtosDesconto: this.produtosDesconto,
            descontoPorProduto: this.opcaoSelecionada,
            OpcaodescontoGlobal: this.opcaodescontoglobal,
            descontoGlobal: this.editedItemProduto.descontoGlobal
          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/clienteInsertOrUpdate', params)
            .then(res => res.data)
          if (!msg.length && msg.affectedRows >= 1) {
            Swal.fire('Cliente registrado com sucesso.','','success')
            this.Limpar()
          } else {
            Swal.fire('Ocorreu um erro ao tentar efectuar a operaçao.','','error')
            this.overlay = false
          }
        } catch (error) {
          this.overlay = false
           Swal.fire('Ocorreu um erro ao tentar efectuar a operaçao.','','error')
        }finally{
          this.overlay = false
        }
      }
    },

    async CarregaProdutos () {
      try {
        //   let  payload =""
        this.overlay = true
        this.produtos = await axios
          .get('/produtosFindall-substituto')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelecionaAplicacao () {
      if (this.opcaoSelecionada === 1) {
        this.descontoFlag = true
      } else { this.descontoFlag = false }
    },

    SelecionaDescontoGlobal () {
      if (this.opcaodescontoglobal === 1) {
        this.flagDescontoGlobal = true
      } else { this.flagDescontoGlobal = false }
    },

    AdicionarTabela () {
      this.editedItemProduto.produto = this.produtoSelecionado.produto
      this.editedItemProduto.preco = utilitarios.IntegerToMoneyValue(this.produtoSelecionado.preco)
    },

    Eliminar (item) {
      let index = this.produtosDesconto.indexOf(item)
      this.produtosDesconto.splice(index, 1)
    },

    AdicionarDesconto () {
      let preco = parseFloat(this.produtoSelecionado.preco)
      let desconto = parseFloat(this.editedItemProduto.desconto)
      let valorDesconto = utilitarios.ObterValorDaPercentagem(preco, desconto)

      let obj = { percentagem: this.editedItemProduto.desconto, valor: valorDesconto, produto: this.produtoSelecionado.pkProduto, descricao: this.produtoSelecionado.codigoBarra + ' - ' + this.produtoSelecionado.produto + ' - ' + this.editedItemProduto.desconto + '%' + ' - ' + utilitarios.IntegerToMoneyValue(valorDesconto) }
      this.produtosDesconto.push(obj)
    },

    showAlert (color, type, icon, message) {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:' + color
      this.iconAlert = icon
      this.alertType = type
      this.msgAlert = message
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    Limpar () {
      this.editedItem.nome = ''
      this.editedItem.nif = ''
      this.editedItem.tipoFornecedor = ''
      this.editedItem.morada = ''
      this.editedItem.telefone1 = ''
      this.editedItem.telefone2 = ''
      this.editedItem.email = ''
      this.editedItem.observacao = ''

      this.$refs.form.resetValidation()
      this.tab = 0
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
